import { makeStyles } from '@material-ui/core/styles';

const LIST_ITEM_HEIGHT = 235;

const useStyles = makeStyles((theme) => ({
    performanceContainer: {
        marginTop: theme.spacing(2),
    },
    toolbarContainer: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        '& .searchContainer': {
            ...theme.mixins.flex.grow(1),
        },
        '& .pagingContainer': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            '& .pagingControlsContainer': {
                marginLeft: 14,
                '& .pagingControls': {
                    padding: theme.spacing(0, 0),
                },
            },
        },
    },
    list: {
        display: 'grid',
        marginTop: theme.spacing(2),
        gridTemplateColumns: 'repeat(auto-fill, minmax(600px, 1fr))',
        gridGap: theme.spacing(2),
        minHeight: LIST_ITEM_HEIGHT,

        '@media print': {
            gridGap: theme.spacing(0, 2),
        },
    },
    listItem: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1.5),
        height: LIST_ITEM_HEIGHT,
        minWidth: 600,

        '@media print': {
            marginBottom: theme.spacing(2),
        },
    },
    listItemTitle: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.alignItemsCenter,
        paddingLeft: theme.spacing(1),

        '& svg, & .MuiIcon-root': {
            marginRight: theme.spacing(1),
            paddingTop: 2,
        },
    },
    dataMessageContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
        ...theme.mixins.flex.grow(1),
        minHeight: LIST_ITEM_HEIGHT,
        '& .dataMessageCenter': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionColumn,
            ...theme.mixins.flex.alignItemsCenter,
            ...theme.mixins.flex.grow(1),
        },
    },
}));

export default useStyles;
